import {
  applyMiddleware,
  combineReducers,
  legacy_createStore as createStore,
} from "redux";
import { thunk } from "redux-thunk";
import settings from "../settings/settingsReducer";
import user from "./userReducer";
import controllers from "../display/controllerReducer";
import scales from "../display/scaleReducer";
import { composeWithDevTools } from "@redux-devtools/extension";
import { persistReducer, persistStore } from "redux-persist";
// es/ (ESM) flavor, not lib/ (CJS): the package-root import above already
// resolves to the es/ build via the "module" field, and Rolldown's dep
// optimizer (Vite 8) mis-unwraps lib/storage's 2-hop CJS default-export
// chain (storage.getItem crash at boot). Same source, ESM flavor, no interop.
import storage from "redux-persist/es/storage";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import chart from "../chart/chartReducer";
import { shop } from "../shop/shopReducer";
import { notifications } from "../display/notificationReducer";
import { persistTransforms } from "./persistTransforms";

const allReducers = combineReducers({
  settings,
  user,
  controllers,
  scales,
  chart,
  shop,
  notifications,
});

// redux-persist@6's `persistReducer` typings predate redux@5's 3-arg `Reducer<S, A, PreloadedState>`
// (combineReducers now declares PreloadedState as `Partial<S>`), which otherwise makes TS collapse
// the exported store's state to `PersistPartial` for any .ts consumer (e.g. src/base/util/api.ts).
// This annotation only affects type inference, not runtime behavior.
/** @type {typeof allReducers} */
const persistedReducer = persistReducer(
  {
    key: "root",
    storage,
    transforms: persistTransforms,
    stateReconciler: autoMergeLevel2,
    // parity with v4: no whitelist/blacklist — all 7 slices persist
  },
  allReducers,
);

const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(thunk)),
);

export const persistor = persistStore(store);

// TODO optimally, we would not export the store, because everytime we import it, we ruin our testing opportunities
export default {
  store,
};
